import { useState } from "react"
import { validateSchedulingConnection } from "../utils/webex-validation"

export default function useSchedulingValidation(organizationId) {
  const [ status, setStatus ] = useState(null)
  const [ message, setMessage ] = useState("")

  const [ referenceId, setReferenceId ] = useState(null)

  function validate(draft) {
    setReferenceId(null)
    setStatus("validating")
    setMessage("")

    validateSchedulingConnection(
      organizationId,
      (success, msg, details) => {
        if (success) {
          setStatus("success")
          setMessage(msg || "Connection verified")
          setReferenceId(details?.reference_id || null)
        } else {
          setStatus("error")
          setMessage(msg || "Validation failed")
        }
      },
      undefined,
      draft
    )
  }

  function reset() {
    setReferenceId(null)
    setStatus(null)
    setMessage("")
  }

  return { status, message, referenceId, validate, reset }
}
